<eau-auction-supplier-container [auctionId]="auctionId" [tenderId]="tenderId"></eau-auction-supplier-container>